import { createSelector } from 'reselect';
import { MetadataConstants, MetadataSelectors } from 'invision-core';
export var IsLoadedSelector = createSelector([MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.OfferingFacet), MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.OfferingFacetCategory)], function (facetLoaded, facetCategoryLoaded) {
  return facetCategoryLoaded && facetLoaded;
});